/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Incode_SecondsInputs */

const en_incode_seconds = /** @type {(inputs: Incode_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incode (Seconds)`)
};

const fr_incode_seconds = /** @type {(inputs: Incode_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incode (secondes)`)
};

const de_incode_seconds = /** @type {(inputs: Incode_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incodieren (Sekunden)`)
};

const it_incode_seconds = /** @type {(inputs: Incode_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incode (secondi)`)
};

const ru_incode_seconds = /** @type {(inputs: Incode_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Входящий код (секунды)`)
};

const es_incode_seconds = /** @type {(inputs: Incode_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incode (Segundos)`)
};

const zh_cn2_incode_seconds = /** @type {(inputs: Incode_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编码（秒）`)
};

const ja_incode_seconds = /** @type {(inputs: Incode_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インコード（秒）`)
};

const hi_incode_seconds = /** @type {(inputs: Incode_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इनकोड (सेकंड)`)
};

const pt_pt2_incode_seconds = /** @type {(inputs: Incode_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incode (segundos)`)
};

/**
* | output |
* | --- |
* | "Incode (Seconds)" |
*
* @param {Incode_SecondsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const incode_seconds = /** @type {((inputs?: Incode_SecondsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Incode_SecondsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_incode_seconds(inputs)
	if (locale === "de") return de_incode_seconds(inputs)
	if (locale === "it") return it_incode_seconds(inputs)
	if (locale === "ru") return ru_incode_seconds(inputs)
	if (locale === "es") return es_incode_seconds(inputs)
	if (locale === "zh-CN") return zh_cn2_incode_seconds(inputs)
	if (locale === "ja") return ja_incode_seconds(inputs)
	if (locale === "hi") return hi_incode_seconds(inputs)
	if (locale === "pt-PT") return pt_pt2_incode_seconds(inputs)
	return en_incode_seconds(inputs)
});